/**
 * ATTENTION: This file is auto generated by using "prepareTemplates".
 * Do not change the content!
 *
 */

/**
 * Library Index form-set to autogenerate all the components and extensions
 * Used by "prepareFormSets"
 */

import FormSet from './form-set/FormSet'
export * from './form-set/FormSet'
export default FormSet
